module.exports = __webpack_public_path__ + "static/media/kids_49.e695db7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_49.jpg
// module id = 5905
// module chunks = 0